import * as yup from "yup";

const schema = yup.object().shape({
  skillname: yup
    .string()
    .min(3, "Minimum 3 characters")
    .required("Name is required"),
  // skillwaitingtime: yup
  //   .number()
  //   .typeError("Tempo de espera deve ser um número")
  //   .required("Tempo de espera é obrigatório"),
  skillinactivitytime: yup
    .number()
    .typeError("Inactivity time must be a number")
    .required("Inactivity time is riquired"),
  skillactiveweightvalue: yup
    .number()
    .min(1, "Minimum 1")
    .max(3, "Maximum 3")
    .typeError("Active chat weight must be a number")
    .required("Active chat weight is required"),
  skillinactiveweightvalue: yup
    .number()
    .min(0.01, "Minimum 0.01")
    .max(1, "Maximum 1")
    .typeError("Inactive chat weight must be a number")
    .required("Inactive chat weight is required"),

  skillslas: yup.array().of(
    yup.object().shape({
      value: yup
        .number()
        .min(1, "Minimum 1")
        .max(7776000, "Maximum 90 days")
        .typeError("SLA must be a number")
        .required("SLA is required"),
    })
  ),
  skillqueuepriority: yup.array().of(
    yup.object().shape({
      value: yup
        .number()
        .transform((cv, ov) => {
          return ov === "" ? undefined : cv;
        })
        .min(0, "Minimum 0")
        .max(20, "Maximum 20")
        .typeError("SLA must be a number"),
    })
  ),
  skillsltime: yup
    .number()
    .integer("Must be integer")
    .min(1, "Minimum 1")
    .typeError("Must be a number")
    .nullable(true),

  skillslgoal: yup.number().when("skillsltime", (e) => {
    if (e) {
      return yup
        .number()
        .integer("Must be integer")
        .min(1, "Minimum 1")
        .max(100, "Maximum 100")
        .typeError("Must be a number")
        .nullable(true)
        .required("Required");
    } else {
      return yup
        .number()
        .integer("Must be integer")
        .min(1, "Minimum 1")
        .max(100, "Maximum 100")
        .typeError("Must be a number")
        .nullable(true);
    }
  }),
});

export default schema;

export const schemaChannelPhone = yup.object().shape({
  skillactiveweightvalue: yup
    .number()
    .min(0, "Minimum 0")
    .max(3, "Maximum 3")
    .typeError("Active chat weight must be a number")
    .required("Active chat weight is required"),
});
